/**
 * Invites Actions
 *
 * Actions for managing invites state in the NGXS store.
 */

import { Invite } from 'src/app/models/schema';

/**
 * Action to initialize invites listener for a user
 * @param email - User's email address (will be normalized to lowercase)
 */
export class InitializeInvites {
  static readonly type = '[Invites] Initialize Invites';
  constructor(public email: string) {}
}

/**
 * Action dispatched when invites data is successfully loaded
 * @param invites - Array of invites for the user
 */
export class InvitesLoaded {
  static readonly type = '[Invites] Invites Loaded';
  constructor(public invites: Invite[]) {}
}

/**
 * Action dispatched when invites loading fails
 * @param error - The error message
 */
export class InvitesLoadFailure {
  static readonly type = '[Invites] Invites Load Failure';
  constructor(public error: string) {}
}

/**
 * Action to clear invites state (e.g., on sign out)
 */
export class ClearInvites {
  static readonly type = '[Invites] Clear Invites';
}

/**
 * Action to set loading state
 * @param loading - Whether invites are loading
 */
export class SetInvitesLoading {
  static readonly type = '[Invites] Set Loading';
  constructor(public loading: boolean) {}
}

